declare global {
  // eslint-disable-next-line no-var, @typescript-eslint/naming-convention
  var __getCognitoExtraHeaders:
  | (() => Promise<Record<string, string>>)
  | undefined;
  interface Window {
    AwsWafIntegration?: {
      getToken: () => Promise<string>;
    };
  }
}

const TIMEOUT_MS = 30000;

class TimeoutError extends Error {
  constructor(type: string) {
    super(`Operation timed out for ${type}`);
    this.name = 'TimeoutError';
  }
}

class AuthService {
  public lastGeneratedReCaptchaToken: string | undefined;

  private async getWAFToken(): Promise<string | null> {
    if (typeof window === 'undefined' || !window.AwsWafIntegration) {
      return null;
    }

    let timeoutId: ReturnType<typeof setTimeout> | undefined;
    try {
      const tokenPromise = window.AwsWafIntegration.getToken();
      const timeoutPromise = new Promise<never>((_, reject) => {
        timeoutId = setTimeout(
          () => reject(new TimeoutError('WAF')),
          TIMEOUT_MS
        );
      });

      const token = await Promise.race([tokenPromise, timeoutPromise]);

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      return token;
    } catch (error) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      console.error('getWAFToken error:', error);
      return null;
    }
  }

  public async getCognitoExtraHeaders(): Promise<Record<string, string>> {
    const wafToken = await this.getWAFToken();

    const extraHeaders: Record<string, string> = {
      'Calo-App-Platform': 'web'
    };

    if (wafToken) {
      extraHeaders['X-Aws-Waf-Token'] = wafToken;
    }

    if (this.lastGeneratedReCaptchaToken) {
      extraHeaders['X-Captcha-Token'] = this.lastGeneratedReCaptchaToken;
    }

    return extraHeaders;
  }
}

export const authService = new AuthService();

globalThis.__getCognitoExtraHeaders = () =>
  authService.getCognitoExtraHeaders();
